import '../HomePage/Quotes.css';
import downloadicon from "../Images/Icon-download-btn.svg"



const DownloadBrochure = ({ url}) => {

    return (
        <>
            <div className="download_brochure">
                <a href={url} target="_blank">
                    Brochure
                    <img className="" src={downloadicon} alt="Home Insurance at Lowest Rates" />
                </a>
            </div>
        </>
    );

}
export default DownloadBrochure;